export default class SerialInfo { 
    sku:string;
    productName:string;
    qty: number;
    serialNoes: Array<string>;
}